import { Button, BUTTON_TYPE, Cart } from '@bepure/tarkin';
import { RegularProduct } from '@bepure/tarkin/dist/utils/cart';
import React, { useEffect, useState } from 'react';
import { debounce } from 'throttle-debounce';


interface Props {
    sku: string;
    product: CartProduct;
    buttonType?: BUTTON_TYPE;
    otherClasses?: string;
    textOverride?: string;
}

export interface CartProduct {
    name: string;
    unit_price: number;
    sku: string;
    imageUrl: string;
    id: number;
    variantId?: number;
    chargeIntervalFrequecy?: number;
    orderIntervalFrequency?: number;
    orderIntervalUnit?: string;
}


const AddToCartBtn = (props: Props) => {
    const [addToCartText, setAddToCartText] = useState(props.textOverride ? props.textOverride : 'Add To Cart');

    useEffect(() => {
        setAddToCartText(props.textOverride ? props.textOverride : 'Add To Cart')
    }, [props.textOverride])

    const addToCart = async () => {
        const cart = Cart.getInstance();
        const cartItems = cart.getItems();
        const product: RegularProduct = {
            name: props.product.name,
            unit_price: props.product.unit_price,
            sku: props.sku,
            imageUrl: props.product.imageUrl,
            productId: props.product.id,
            quantity: cartItems[props.product.id]?.quantity + 1 || 1,
            variantId: props.product.variantId || undefined,
            chargeIntervalFrequecy: props.product.orderIntervalFrequency ? +props.product.orderIntervalFrequency : undefined,
            orderIntervalFrequency: props.product.orderIntervalFrequency ? +props.product.orderIntervalFrequency : undefined,
            orderIntervalUnit: props.product.orderIntervalUnit || undefined
        };
        setAddToCartText('Adding To Cart...')
        await cart.updateItem(product).then(() => {
            setAddToCartText('Added To Cart!')
        });
    }

    const addToCartClick = () => {
        addToCartClickDebounce();
    }

    const addToCartClickDebounce = debounce(500, false, () => {
        setAddToCartText('Added To Cart!')
        addToCart();
        setTimeout(() => {
            setAddToCartText('Add To Cart')
        }, 3000)
    });


    return (
        <Button 
            text={addToCartText}
            ariaLabel={'add-to-cart'}
            icon={'shopping_cart'}
            onClick={addToCartClick}
            button_type={props.buttonType}
            otherClasses={props.otherClasses}
        />
    )
}

export default AddToCartBtn;